module.exports = __webpack_public_path__ + "static/media/Watch&Earn_PopupIcon@3x.44f1d364.png";